import script from "./sidebarView.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebarView.vue?vue&type=script&setup=true&lang=js"

import "./sidebarView.vue?vue&type=style&index=0&id=1de32d69&scoped=true&lang=css"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de32d69"]])

export default __exports__